import instance from "./instance";

export const registerGlanceView = (data) => {
  return async (dispatch, getState) => {
    try {
      await instance.post("/analytics/glance/", data);
    } catch (err) {
      console.error(err);
    }
  };
};
